import React from 'react';
import LocationTemplate from './LocationTemplate';

const RoanokeRapidsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Roanoke Rapids"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27870"]}
      latitude={36.4615}
      longitude={-77.6541}
      population={15329}
      historicalFact="Named after the rapids in the Roanoke River; developed as a major textile manufacturing center."
      nearbyTowns={[
        "Weldon, NC",
        "Halifax, NC",
        "Gaston, NC",
        "Garysburg, NC",
        "Enfield, NC",
        "Scotland Neck, NC",
        "Littleton, NC",
        "South Hill, VA"
      ]}
    />
  );
};

export default RoanokeRapidsPage;